import { el, shortDate } from './ui'

// The app's version, counted one at a time (Liam, 26 Oct 2026: "How can I test my version number ... Is there a way we
// count it? An easy way so I can keep track. I know Lingolab we do it one at a time"). Each build that goes live is the
// next number: scripts/release.zsh counts the builds already live, bakes the next one into this build and writes it to
// /version.json beside it. More shows this phone's number, and says when a newer one is live.
declare const __ROUNDLY_VERSION__: string
declare const __ROUNDLY_VERSION_DAY__: string
export const APP_VERSION: string = typeof __ROUNDLY_VERSION__ === 'string' ? __ROUNDLY_VERSION__ : ''
const APP_VERSION_DAY: string = typeof __ROUNDLY_VERSION_DAY__ === 'string' ? __ROUNDLY_VERSION_DAY__ : ''

// "Version 27 · 26 Oct", then "the latest" or "Version 28 is out: close Roundly and open it again". Nothing on a copy that
// was not built by a release (a computer running it by hand, the checks).
export function versionLine(): HTMLElement | null {
  if (!APP_VERSION) return null
  // The day it was built, as this round writes its dates ("26 Oct" in the UK, "Oct 26" in the US): baked as 2026-10-26.
  const day = /^\d{4}-\d{2}-\d{2}$/.test(APP_VERSION_DAY) ? shortDate(APP_VERSION_DAY) : APP_VERSION_DAY
  const line = el('p', { class: 'muted app-version' }, `Version ${APP_VERSION}${day ? ` · ${day}` : ''}`)
  void fetch(`/version.json?r=${Date.now()}`, { cache: 'no-store' }).then((r) => (r.ok ? r.json() : null)).then((live: { version?: number } | null) => {
    const now = Number(live?.version)
    if (!Number.isFinite(now)) return
    line.append(now > Number(APP_VERSION) ? `: version ${now} is out. Close Roundly and open it again to get it.` : ': the latest')
  }).catch(() => {})
  return line
}
